import React from 'react';
import '../styles/SearchesTable.css';
import { format, fromUnixTime } from 'date-fns';
import { formatterLong } from '../styles/GlobalStyles';

function SearchesTable(props) {
    const data = props.data;
    const companies = props.companies;

    const headings = [
        {
            preIcon: null,
            label: "Address",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Date",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Time",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Company",
            postIcon: null
        },
        {
            preIcon: null,
            label: "User",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Method",
            postIcon: null
        },
        {
            preIcon: null,
            label: "Cost",
            postIcon: null
        }
    ];

    const getCompany = (companyId) => {
        const companyIndex = companies.findIndex(e => e.id === companyId);
        if ( companyIndex === -1 ) {
            return null;
        }
        return companies[companyIndex].data.companyName;
    };

    const getUser = (companyId, userId) => {
        const companyIndex = companies.findIndex(e => e.id === companyId);
        if ( companyIndex === -1 ) {
            return null;
        }
        const companyObject = companies[companyIndex].data;
        const userIndex = companyObject.users.findIndex(e => e.userId === userId);
        if ( userIndex === -1 ) {
            return null;
        }
        return `${companyObject.users[userIndex].firstName} ${companyObject.users[userIndex].lastName}`;
    };

    const viewProperty = (item) => {
        const countyId = item.countyId;
        const propertyId = item.propertyId;
        window.open(`/run-comps/${countyId}/${propertyId}`, "_blank");
    };

    return (
        <div className="searches-table-outer-container">
            <table 
                className="searches-table-container"
            >
                <thead className="">
                    <tr className="bg-colour-white">
                        {
                            headings.map((item, index) =>
                                <th 
                                    className="searches-table-label-element"
                                    key={index}
                                >
                                    <span className="body-regular colour-secondary">
                                        {item.label}
                                    </span>
                                </th>
                            )
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item, index) =>
                            <tr 
                                key={index}
                                className=""
                            >
                                <td className="searches-table-value-element">
                                    <span 
                                        className="body-semibold colour-primary cursor-pointer"
                                        onClick={() => viewProperty(item.data)}
                                    >
                                        {item.data.address.streetAddress}
                                    </span>
                                </td>
                                <td className="searches-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {format(fromUnixTime(item.data.date._seconds), "MMM dd, yyyy")}
                                    </span>
                                </td>
                                <td className="searches-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {format(fromUnixTime(item.data.date._seconds), "HH:mm")}
                                    </span>
                                </td>
                                <td className="searches-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {
                                            getCompany(item.data.companyId) !== null &&
                                            getCompany(item.data.companyId)
                                        }
                                    </span>
                                </td>
                                <td className="searches-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {
                                            getUser(item.data.companyId, item.data.userId) !== null &&
                                            getUser(item.data.companyId, item.data.userId)
                                        }
                                    </span>
                                </td>
                                <td className="searches-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {
                                            item.data.method !== undefined && item.data.method !== null
                                                ? item.data.method
                                                : "-"
                                        }
                                    </span>
                                </td>
                                <td className="searches-table-value-element">
                                    <span className="body-regular colour-primary">
                                        {
                                            item.data.totalCost !== undefined &&
                                            formatterLong.format(item.data.totalCost).replace(".00", "")
                                        }
                                    </span>
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    )
};

export default SearchesTable;